module.exports = __webpack_public_path__ + "img/修改gld_gbt823_1988.prt.ec3a700e.jpg";